import { createAsyncThunk } from "@reduxjs/toolkit";
import { customFetch } from "../lib/network/Axios";
import { handleError } from "../lib/ErrorHandler";
import { jwtDecode } from "jwt-decode";
import { TokenPayload } from "../types/constants.types";
import config from "../config";

const api = config.apiBaseUrl;

const adminAuthHeaders = {
	"x-app-type": "admin",
};

export const requestPasswordReset = async (email: string) => {
	await customFetch.post(
		api + "/auth/forgot-password",
		{ email },
		{ headers: adminAuthHeaders },
	);
};

export const resetPassword = async ({
	email,
	token,
	newpassword,
}: {
	email: string;
	token: string;
	newpassword: string;
}) => {
	await customFetch.put(
		api + "/auth/reset-password",
		{ email, token, newpassword },
		{ headers: adminAuthHeaders },
	);
};

export const loginAPI = createAsyncThunk(
	"auth/login",
	async ({ email, password }: { email: string; password: string }) => {
		try {
			const response = await customFetch.post(api + "/auth/login", {
				email: email,
				password: password,
			});
			if (!response || response.status !== 200 || !response?.data.accessToken) {
				throw new Error("Authentication failed");
			}

			const token = response.data.accessToken;
			const decodedToken = jwtDecode<TokenPayload>(token);
			const role = decodedToken.role || "";

			// Get user data from the response
			const userData = response.data.user || {
				username: email,
			};

			// Save to localStorage
			localStorage.setItem("user", JSON.stringify({
				email: email,
				name: userData.name || "",
			}));

			return {
				accessToken: token,
				email: email,
				role: role,
			};
		} catch (error) {
			console.log(error);
			handleError(error);
			throw new Error("Invalid username or password. Please try again.");
		}
	},
);

export const registerAPI = createAsyncThunk(
	"auth/register",
	async ({
		name,
		email,
		password,
	}: {
		name: string;
		email: string;
		password: string;
	}) => {
		try {
			const response = await customFetch.post(api + "/auth/register", {
				name: name,
				email: email,
				password: password,
			});
			if (response && response.status == 201) {
				var token = response?.data.accessToken;
				const decodedToken = jwtDecode<TokenPayload>(token);
				const role = decodedToken.role || "";
				return { accessToken: token, email: email, role: role };
			}
			throw new Error("Registration failed");
		} catch (error) {
			console.log({ registerAPI: error });
			handleError(error);
			throw error;
		}
	},
);

export const logoutAPI = createAsyncThunk(
	"auth/logout",
	async (email: string) => {
		try {
			const response = await customFetch.post(api + "/auth/logout", {
				email,
			});
			if (response) {
				localStorage.setItem("accessToken", "");
				localStorage.setItem("user", "");
			}
			return response;
		} catch (error) {
			console.log({ loginAPI: error });
			handleError(error);
		}
	},
);

export const validateToken = createAsyncThunk(
	"auth/validate",
	async (email: string) => {
		try {
			console.log("INSIDE VALIDATE TOKEN", api + "/auth/validate", email);
			const data = await customFetch.post(api + "/auth/validate", {
				email: email,
			});
			return data;
		} catch (error) {
			console.log({ refreshTokenAPI: error });
			handleError(error);
		}
	},
);

export const refreshTokenAPI = async (
	email: string,
	refreshToken: string | null,
) => {
	try {
		const data = await customFetch.post(api + "auth/refresh", {
			email: email,
			refreshToken: refreshToken,
		});
		return data;
	} catch (error) {
		console.log({ refreshTokenAPI: error });
		handleError(error);
	}
};
